import { axiosClientv1 } from "./apiClient";
import type { ApiResponse } from "../Types";

export const GetBulkPayments = async (params: {
  entity_type?: string;
  entity_id?: string;
  page?: number;
  limit?: number;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/bulk-payments`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load bulk payments.",
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const GetBulkPaymentDetail = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/bulk-payments/detail`, {
      params: { id },
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to load bulk payment details.",
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};
